import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { SmallButton } from 'Components/Fields/Buttons';
import { timestampToDate, formatDateRange } from 'Utils/Format';
import { CardInfo } from 'Components/CardInfo';
import PayPalInfo from 'Features/Payment/PayPalInfo';
import { ApplePayInfo } from 'Features/Payment/ApplePayInfo';

function BillingHistoryItem({ payment, invoiceRouteRoot }) {
  let discountsDesc = '';
  let discountsAmount = 0;

  const { paymentID, orderProductInfo, paymentsInfo, totalTaxCharged = 0 } = payment;
  const [showDetail, onToggleDetail] = useState(false);
  const { displayName, discounts = {}, startDate, endDate, retailPrice } = orderProductInfo.find((o) => o.appId);
  let parentDisplayName = displayName;
  const hasDiscounts = !isEmpty(discounts);
  if (hasDiscounts) {
    const { discountAmount = 0, type = '', description, promotionName } = discounts;
    discountsAmount = discountAmount;
    parentDisplayName = description;
    discountsDesc = type === 'Voucher' ? promotionName : parentDisplayName;
  }

  const [{ receivedDate = 0, cardType, creditCardNumber, amount, paymentType, email = '', applePayID = '' }] =
    paymentsInfo;
  const totalCharged = amount < 0 ? `-$${(amount * -1).toFixed(2)}` : `$${amount.toFixed(2)}`;
  const billDate = timestampToDate(receivedDate, 2);
  const billingPeriod = formatDateRange(startDate, endDate);

  return (
    <li className="billingListItem">
      <div className="sectionFlex billingSummary" role="button" onClick={() => onToggleDetail(!showDetail)}>
        <span className="firstCol">{billDate}</span>
        <span className="secondCol">{parentDisplayName}</span>
        <span className="thirdCol">{billingPeriod}</span>
        <span className="fourCol">
          <span className="listPrice">{totalCharged}</span>
          <i className={`arrow ${showDetail ? 'upArrow' : 'downArrow'}`} />
        </span>
        <Link className="viewLink" to={`${invoiceRouteRoot}/${paymentID}`}>
          <SmallButton text="View" />
        </Link>
      </div>

      {showDetail && (
        <div className="paymentDetail">
          {retailPrice && (
            <div className="sectionFlex paymentDetailItem">
              <span className="detailLabel">{displayName}</span>
              <span className="detailPrice">${retailPrice.toFixed(2)}</span>
            </div>
          )}
          <div className="sectionFlex paymentDetailItem">
            <span className="detailLabel">Tax</span>
            <span className="detailPrice">${totalTaxCharged.toFixed(2)}</span>
          </div>
          {hasDiscounts && discountsAmount > 0 && (
            <div className="sectionFlex paymentDetailItem">
              <span className="detailLabel">{discountsDesc}</span>
              <span className="detailPrice">{`-$${discountsAmount.toFixed(2)}`}</span>
            </div>
          )}
          {paymentType === 'Credit/Debit Card' && (
            <div className="sectionFlex paymentDetailItem">
              <CardInfo cardNumber={creditCardNumber} cardType={cardType} />
            </div>
          )}
          {paymentType === 'PayPal Account' && (
            <div className="sectionFlex paymentDetailItem">
              <PayPalInfo email={email} />
            </div>
          )}
          {paymentType === 'ApplePay' && (
            <div className="sectionFlex paymentDetailItem">
              <ApplePayInfo applePayID={applePayID} />
            </div>
          )}
        </div>
      )}
    </li>
  );
}

export default BillingHistoryItem;
